import React from "react";
import SectionHeader from "./SectionHeader";
import { stats, profile } from "../mock";

const About = () => {
  return (
    <section id="about-detail" className="relative px-6 lg:px-10 py-20 border-t border-[#1c2533]">
      <div className="max-w-7xl mx-auto">
        <SectionHeader num="01 // PROFILE" title="ABOUT THE ANALYST" subtitle="WHO // WHAT // WHY" />

        <div className="grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-7 space-y-5 text-slate-300 leading-relaxed text-[15px]">
            <p>
              I&apos;m a <span className="text-cyan-400">SOC Analyst with 4+ years</span> of
              hands-on experience running real-time monitoring, incident response, and threat
              analysis inside 24x7 enterprise Security Operations Centers &mdash; including both
              In-House SOC and Global SOC (GSOC) functions.
            </p>
            <p>
              My day-to-day spans <span className="text-cyan-400">SIEM operations on Splunk </span>,
              endpoint defense on SentinelOne, Carbon Black, Microsoft Defender, and Red
              Canary, email security via Proofpoint, and Cofense, and cloud
              security on Wiz. I enrich incidents through ThreatQ, drive bridge calls during
              critical escalations, and document everything to SOC SLA standards.
            </p>
            <p>
              I work entirely within the{" "}
              <span className="text-cyan-400">MITRE ATT&amp;CK and NIST frameworks</span> &mdash;
              hunting through IOCs, endpoint telemetry, DNS, web, firewall, and cloud logs to
              surface real threats and reduce noise. I also build tooling on the side; my
              IOC Analyzer accelerates triage by automating malicious IP, domain, URL, and hash
              enrichment.
            </p>

            <div className="mt-8 border border-[#1c2533] bg-[#0c1118] p-5 rounded-sm corner-brackets">
              <div className="font-mono text-[10px] tracking-[0.22em] text-cyan-400 mb-2">
                CURRENT STATUS
              </div>
              <div className="flex items-center gap-3">
                <span className="w-2 h-2 rounded-full bg-emerald-400 pulse-dot" />
                <span className="font-mono text-sm text-slate-100">{profile.status}</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 grid grid-cols-2 gap-3">
            {stats.map((s, i) => (
              <div
                key={i}
                className={`border border-[#1c2533] bg-[#0c1118] p-5 card-hover ${
                  i === stats.length - 1 ? "col-span-2" : ""
                }`}
              >
                <div className="font-mono text-3xl md:text-4xl font-bold text-cyan-400 mb-1.5 glow-cyan">
                  {s.value}
                </div>
                <div className="font-mono text-[10px] tracking-[0.18em] text-slate-400">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
